/**
 * @module app.kya.list.cancelContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CancelContractCtrl($scope, $uibModalInstance, $log) {
        let self = {};

        self.cancel = function() {
            $uibModalInstance.close(true);
        };

        self.doNotCancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    CancelContractCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular
        .module('app.kya.list.cancelContractCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('CancelContractCtrl', CancelContractCtrl);
});
